/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flow_Order_5Inputs */

const en_flow_order_5 = /** @type {(inputs: Flow_Order_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business Central invoices it.`)
};

/**
* | output |
* | --- |
* | "Business Central invoices it." |
*
* @param {Flow_Order_5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const flow_order_5 = /** @type {((inputs?: Flow_Order_5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flow_Order_5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_flow_order_5(inputs)
});